<template lang="pug">
.home

  Headline
  HowItWorks
  Brands
  Why

  Offer(
    :subscriptionGiftPromotions="availableSubscriptionGiftPromotions"
  )

  Boxes

  ClientOnly
    SubscriptionGiftPopup(
      v-if="promotionIsAvailable",
      :subscription-gift-promotions="availableSubscriptionGiftPromotions"
    )
</template>
<script setup lang="ts">
import type { WatchStopHandle } from "vue"
import type { SubscriptionGiftAvailabilityResponse } from "~/services/subscription/promotion/promotionService"
import PromotionService from "~/services/subscription/promotion/promotionService"

import Boxes from "./Sections/Boxes.vue"
import Brands from "./Sections/Brands.vue"
import Headline from "./Sections/Headline.vue"
import HowItWorks from "./Sections/HowItWorks.vue"
import Offer from "./Sections/Offer.vue"
import Why from "./Sections/Why.vue"
import SubscriptionGiftPopup from "./Promotions/SubscriptionGift/SubscriptionGiftPopup.vue"
import { useActiveSubscription } from "~/store/subscription/subscription"

useHead({
  title: "Box Magenta"
})

definePageMeta({
  alias: [ '/oferta' ]
})

const route = useRoute()
const experiments = useExperiments()
const freeShippingSP = ref(false)
const availableSubscriptionGiftPromotions = ref<SubscriptionGiftAvailabilityResponse[]>([])
const subscription = useActiveSubscription()

const promotionIsAvailable = computed(() => {
  return availableSubscriptionGiftPromotions.value.find((promotion) =>
    promotion.ruleId == "2023-08-loccitane-au-bresil-01" || promotion.ruleId == "2023-08-loccitane-au-bresil-02"
  ) != undefined
})

const goToOffer = () => {
  setTimeout(() => {
    document.getElementById("oferta")?.scrollIntoView({
      behavior: "smooth",
    })
  })
}

var experimentsStopHandle: WatchStopHandle | null = null
onMounted(() => {
  if (route.path == "/oferta") {
    goToOffer()
  }

  experimentsStopHandle = watchEffect(() => {
    freeShippingSP.value = experiments.get('freeShippingSP') === 'true'
  })

  PromotionService.listAvaiableSubscriptionGiftPromotions().then((response) => {
    availableSubscriptionGiftPromotions.value = response
  }).catch((error) => {
    captureException(new Error('Failed to list available subscription gift promotions', { cause: error }))
  })
})

onUnmounted(() => {
  experimentsStopHandle?.apply(this)
})
</script>
<style lang="sass" scoped>
@import '~/assets/styles/mixins'

.home
  margin: 24px 0 0
</style>
<style lang="sass">
@import '~/assets/styles/mixins'

.banner
  .banner--spacer
    position: relative
    width: 100%
    height: 46px

  .banner--content
    position: fixed
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    gap: 4px
    top: 0
    left: 0
    width: 100%
    padding: 8px
    font-size: 16px
    color: white
    background-color: #ef368b
    box-shadow: 0 4px 12px 0 #ef368b82
    z-index: 500
    text-align: center

    *
      color: white

    .emoji
      font-size: 16px

    a
      text-decoration: underline

  @include tablet
    .banner--content
      font-size: 14px
</style>
